import { TNCEntryInfo } from 'types/api/b2ciam';
import { TokenResponse } from 'types/api/token';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type AcceptTncOptions = {
  accessToken?: string;
  tncEntryInfo?: TNCEntryInfo;
};

export function acceptTnc({
  accessToken,
  tncEntryInfo
}: AcceptTncOptions): FetchResponse<TokenResponse> {
  return fetchReq({
    body: {
      grant_type: 'terms_and_conditions',
      serviceName: 'vme',
      spServiceId: '3',
      termsGUIDs: tncEntryInfo
    },
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    mark: 'accept_tnc',
    method: 'POST',
    url: endpoints.token.tnc
  });
}
